<template>
  <point-detail :is-create="false" />
</template>

<script>
import PointDetail from './detail'
export default {
  name: 'EditPointGoods',
  components: { PointDetail }
}
</script>
